import styled from "styled-components";

export const LastLoginDefaultBox = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    font-size: 1.1rem;
    ${({theme}) => theme.font.presets.regular};
    line-height: 1.2;
    margin: 0 0 0 1.2rem;
    padding: 0 0 0 1.2rem;
    border-left: 1px solid ${props => props.theme.colors.textMiddleDark};

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        flex-direction: row;
        align-items: center;
        font-size: 1rem;
        padding-bottom: 0rem;
        line-height: 1;
    }

`;
